import { render, staticRenderFns } from "./diff_stats_dropdown.vue?vue&type=template&id=49816d56&scoped=true"
import script from "./diff_stats_dropdown.vue?vue&type=script&lang=js"
export * from "./diff_stats_dropdown.vue?vue&type=script&lang=js"
import style0 from "./diff_stats_dropdown.vue?vue&type=style&index=0&id=49816d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49816d56",
  null
  
)

export default component.exports